import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301) till /offerter. */
export const Route = createFileRoute("/jamfor-offerter/")({
  head: () => seoHead("/jamfor-offerter"),
  beforeLoad: () => permanentRedirect("/offerter"),
});
